import { useModal } from "@hooks/useModal";
import { createModalHelpers } from "@stores/unified-modal.store";
import { useTonConnectModal, useTonConnectUI } from "@tonconnect/ui-react";
import cn from "classnames";
import { FC } from "react";
import Modal from "../Modal";
import ModalContent from "../Modal/ModalContent";
import styles from "./Wallet.module.scss";
import { useConnectWallet } from "./hooks/useConnectWallet";

const Connect: FC = () => {
    const { state, open } = useTonConnectModal();
    const [tonConnectUI] = useTonConnectUI();
    const { connectWallet, openModal, closeModal } = createModalHelpers();
    const [_, handleCloseModal] = useModal(() => closeModal("connectWallet"));
    useConnectWallet((isVisible) => (isVisible ? openModal("connectWallet") : closeModal("connectWallet")));

    return (
        <Modal
            isVisible={connectWallet && state.status !== "opened" && !tonConnectUI.connected}
            setIsVisible={(isVisible) => (isVisible ? openModal("connectWallet") : closeModal("connectWallet"))}
        >
            <ModalContent classNames={styles.content}>
                <div className={styles.header}>
                    <h2 className={styles.headline}>Connect wallet</h2>
                    <button className={styles.close} onClick={handleCloseModal}>
                        <picture>
                            <source
                                srcSet="/images/modal/closemobile.svg"
                                width={7.5}
                                height={7.5}
                                media="(max-width: 768px)"
                            />
                            <img
                                height={12}
                                width={12}
                                src="/images/modal/close.svg"
                                style={{ opacity: 0.4 }}
                                alt="Close modal"
                            />
                        </picture>
                    </button>
                </div>
                <p className={styles.description}>
                    To use the sniper and fast transactions, you need to create a new wallet. To use swap, you can use
                    your wallet
                </p>
                <a className={styles.link} href="/">
                    <span>Learn more</span>
                    <img width={8} height={8} src="/images/modal/learnarrow.svg" alt="" />
                </a>
                <div className={styles.buttons}>
                    <button onClick={open} className={styles.button}>
                        <div className={styles.text}>
                            <div className={styles.wallet}>Connect your wallet</div>
                        </div>
                        <div className={cn(styles.img, styles.ton)}>
                            <img height={22} width={22} src="/images/modal/ton.svg" alt="" />
                        </div>
                    </button>
                </div>
            </ModalContent>
        </Modal>
    );
};

export default Connect;
